import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as customPriceActions from '../../../../actions/customPriceAction';
import CustomPrices from './CustomPrices';
import * as hotelActions from './../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        customPriceState: state.customPriceReducer,
        hotelState: state.hotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListPrices: (filters) => dispatch(customPriceActions.getListPrices(filters)),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CustomPrices));
